import "./DentalInfoSummary.scss";
import * as React from "react";
import { DentalInfo } from "./DentalInfo";
import DentalInformationItemsList from "../patient-management/DentalInformationItemsList";
import EditAction from "../commons/components/action/EditAction";

export default function DentalInfoSummary({
  forMyself,
  dentalInfo,
  editAction,
  showEditDentalInfoForm,
}: {
  forMyself: boolean;
  dentalInfo: DentalInfo;
  editAction: boolean;
  showEditDentalInfoForm: (boolean) => any;
}) {
  return (
    <div className="dental-info-summary">
      <div className="panel-title h-flex space-between no-wrap">
        <div>{i18n["Page.Portal.DentalInformation.Title"]}</div>
        {editAction && <EditAction onClick={showEditDentalInfoForm} />}
      </div>
      <div>
        {editAction ? (
          <DentalInformationItemsList dentalInfo={dentalInfo} fullDetails={false} />
        ) : (
          <div className={"h-flex centered action-container"}>
            <button className="button-secondary small" onClick={showEditDentalInfoForm}>
              {
                i18n[
                  forMyself
                    ? "Page.Portal.DentalInformation.CompleteInformation.ForMyself.Button"
                    : "Page.Portal.DentalInformation.CompleteInformation.Button"
                ]
              }
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
